module.exports = __webpack_public_path__ + "static/media/dialogduk2.cddeffc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dialogduk/static/dialogduk2.png
// module id = 162
// module chunks = 0